<template>
    <div class="share-wrap">
        <div class="invite_wrap">
        <div class="basic_wrap" style="color:white;">

            <div class="top-bg">
                <div class="avta-div">
                    <img class="avta" src="../images/user/default_avt.png" alt="">
                </div>
                <!-- <p class="userphone"> {{ userinfo.mobile }} </p> -->
                <div class="uid"> ID:{{ userinfo.id }}</div>
                <div class="uid2"> {{ $t("我的邀请链接") }}</div>
                <div class="linkcode">
                    <b> {{ userinfo.invite_http }} </b>
                    <img class="copy-img" @click="doCopy(userinfo.invite_http)" src="../images/user/copy2.png" style=""
                        alt="">
                </div>

            </div>
            <div class="mid_bg">
              <div class="all-com"> R$<b style="color: gold;position: absolute;margin-left: 25px;">{{ userinfo.commission_money }}</b> <b>{{ $t("总计") }}</b></div>
              <div class="withdraw_button">
                <div @click="$router.push('commission_cash')">
                  <img src="../images/user/wytx.png" alt="" class="withdraw_img"/>
                  <p>{{  $t('我要提现') }}</p>
                </div>
                <div @click="commission_change()">
                  <img src="../images/user/commission_change.png" alt="" class="withdraw_img"/>
                  <p>{{  $t('佣金转换') }}</p>
                </div>
              </div>
            </div>
            <div class="bottom_bg">
              <div class="search-wrap">
                <input class="input-keyword" type="text" v-model="keyword" placeholder="ID">
                <img class="simg" src="../images/home/s_a.png" alt="" @click="search()">
              </div>
              <div class="tab-head">
                <button :class="level == 'A' ? 'tab-button button-active' : 'tab-button'" @click="getUserByType('A')">A({{userinfo.subOneRecharge}}/{{userinfo.subOne}})</button>
                <button :class="level == 'B' ? 'tab-button button-active' : 'tab-button'" @click="getUserByType('B')">B({{userinfo.subTwoRecharge}}/{{userinfo.subTwo}})</button>
                <button :class="level == 'C' ? 'tab-button button-active' : 'tab-button'" @click="getUserByType('C')">C({{userinfo.subThreeRecharge}}/{{userinfo.subThree}})</button>
              </div>
              <div class="hoho">
                <div class="item">
                  {{ $t("ID") }}
                </div>
                <div class="item">
                  {{ $t("是否充值") }}
                </div>
                <div v-for="(item, index) in subUser" :key="index">
                  <div class="item">{{ item.id}}</div>
                  <div class="item">
                    {{ item.is_recharge == 1}}
                  </div>
                </div>
              </div>
            </div>

<!--            <div class="hoho">-->
<!--                <div class="item">-->
<!--                    {{ $t("类别") }}-->
<!--                </div>-->
<!--                <div class="item" style="font-size: 0.5rem; color: gold;">-->
<!--                    A -->
<!--                </div>-->
<!--                <div class="item">{{ $t("邀请人数") }}</div>-->
<!--                <div class="item">-->
<!--                    {{ userinfo.subOne }}-->
<!--                </div>-->
<!--                <div class="item">{{ $t("充值人数") }}</div>-->
<!--                <div class="item">-->
<!--                    {{ userinfo.subOneRecharge }}-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="hoho">-->
<!--                <div class="item">-->
<!--                    {{ $t("类别") }}-->
<!--                </div>-->
<!--                <div class="item" style="font-size: 0.5rem; color: gold;">-->
<!--                     B-->
<!--                </div>-->
<!--                <div class="item">{{ $t("邀请人数") }}</div>-->
<!--                <div class="item">-->
<!--                    {{ userinfo.subTwo }}-->
<!--                </div>-->
<!--                <div class="item">{{ $t("充值人数") }}</div>-->
<!--                <div class="item">-->
<!--                   {{ userinfo.subTwoRecharge }}-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="hoho">-->
<!--                <div class="item">-->
<!--                    {{ $t("类别") }}-->
<!--                </div>-->
<!--                <div class="item" style="font-size: 0.5rem; color: gold;">-->
<!--                      C-->
<!--                </div>-->
<!--                <div class="item">{{ $t("邀请人数") }}</div>-->
<!--                <div class="item">-->
<!--                   {{ userinfo.subThree }}-->
<!--                </div>-->
<!--                <div class="item">{{ $t("充值人数") }}</div>-->
<!--                <div class="item">-->
<!--                   {{ userinfo.subThreeRecharge }}-->
<!--                    </div>-->
<!--            </div>-->


        
            <!-- <div class="ic-rule">
                <p>{{ $t("邀请规则") }}</p>
                <div>
                    {{ $t("邀请一个有效充值客户,您将获取") }} <b style="color:gold"> R${{ userinfo.invite_rate }}</b>
                    <br> {{ $t("系统自动发放,马上到账") }}
                </div>
            </div>

            <div class="ic-rule">
                <p>{{ $t("额外奖励") }}</p>
            </div>
            <div class="ewai">
                <div class="left-one">{{ $t("累计人数") }}</div>
                <div class="right-one">{{ $t("奖励金额") }}</div>
                <div class="r-wrap" v-for="(item, index) in userinfo.other_rewards" :key="index">
                    <div class="left-one">{{ item.invite_num }}</div>
                    <div class="right-one">R$ {{ item.reward_amount }}</div>
                </div>


            </div> -->

        </div>
      <van-popup v-model="show" class="popup_style" >
        <div class="popup_yue">
          <p class="total-asset2">{{ $t('佣金余额') }}:</p>
          <p class="total-number2">${{ userinfo.commission_money }}</p>
        </div>
        <div class="popup_change">
          <p class="total-asset3">{{ $t('转换金额') }}($):</p>
          <input class="total-number3" v-model="money"/>
        </div>
        <div class="popup_button">
          <button class="total-asset4" @click="popup_cancel()">{{ $t('取消') }}</button>
          <button class="total-number4" @click="popup_commit()">{{ $t('提交') }}</button>
        </div>
      </van-popup>
    </div>

      


        <div class="invite-reward">
            <div class="reward-title">
                Atualizar a cada hora
            </div>
            <div class="jiangli">
                <div class="item">
                    <div class="vnub">0/0</div>
                    <div class="des">Total Invitado</div>
                </div>
                <div class="item">
                    <div class="vnub">0/0</div>
                    <div class="des">Renda total</div>
                </div>
                <div class="item">
                    <div class="vnub">0/0</div>
                    <div class="des">Invitado Hoje</div>
                </div>
                <div class="item">
                    <div class="vnub">0/0</div>
                    <div class="des">Renda Hoje</div>
                </div>
                <div class="item">
                    <div class="vnub">0/0</div>
                    <div class="des">Estimativa salarial</div>
                </div>
                <div class="item">
                    <div class="vnub">0/0</div>
                    <div class="des">Salário do último mês</div>
                </div>
                <div class="item">
                    <div class="vnub">0/0</div>
                    <div class="des">Bônus Convidado/Mês</div>
                </div>
                <div class="item">
                    <div class="vnub">0/0</div>
                    <div class="des">Comissão/Mês</div>
                </div>
            </div>
        </div>



    </div>
</template> 
<script>
import Fetch from "../../utils/fetch";
import bsHeader from "../../components/bsHeader.vue";
import Vue from "vue";
import { Empty } from "vant";
import Clipboard from "v-clipboard";


export default {
    name: "share",
    data() {
        return {
            data: {
                reward: {
                    invest1: "4.00",
                    invest2: "2.00",
                    invest3: "1.00",
                },

            },
            userinfo: {},
            keyword: null,
            subUser: [],
            level:'A',
            levelList: ['A','B','C'],
            show: false,
            money: 0
        };
    },
    components: {
        bsHeader,
    },
    created() {
        this.$parent.footer("share");
    },
    mounted() {
        this.start();
        this.subUserList();
    },
    methods: {
      popup_cancel() {
        this.show = false
      },
      popup_commit() {
        Fetch("/user/commissionChange", { money: this.money }).then((r) => {
          this.show = false
          console.log(r);
        });
      },
      commission_change() {
        this.show = true
      },
      getUserByType(type) {
        this.level = type;
        this.subUserList();
      },
      subUserList() {
        Fetch("/user/subLevelUser", { level: this.level }).then((r) => {
          this.subUser = r.data
          console.log(r);
        });
      },
        doCopy(val) {
            let _this = this;
            this.$copyText(String(val)).then(
                function (e) {
                    _this.$toast({
                        background: "#07c160",
                        message: _this.$t("复制成功"),
                    });
                },
                function (e) {
                    //console.log(e);
                }
            );
        },
        search() {
            Fetch("/user/subLevel", { user_id: this.keyword }).then((r) => {
                console.log(r);
                if (r.data != "0") {
                    this.$toast({
                        //type:'fail',
                        icon: require("../images/common/laugh.png"),
                        background: "#07c160",
                        message: "YES" + ": " + r.data,
                        duration: 5000,
                        className: "mytoast"

                    });
                }else{
                    this.$toast({
                      
                        background: "#07c160",
                        message: "NO",
                        duration: 5000,
                        className: "mytoast"

                    });
                }
            });
        },
        handleError() {
            this.$messagesouth({
                message: "Replication failed",
                type: "comm",
                center: true,
            });
        },
        start() {
            Fetch("/user/myTeam").then((r) => {
                //console.log(r);
                this.userinfo = r.data;
            });
        },

        copy() {
            this.$toast({
                background: "#07c160",
                message: this.$t("invest_qrcode.copySucceeded"),
            });
        },


    },
};
</script>
<style scoped>
.des {
    width: 100%;
    height: 4vh;
    line-height: 4vh;

}

.vnub {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    font-size: 2.5vh;
}

.item {
    width: 50%;
    text-align: center;
    color: #fff;
    font-size: 2vh;
    font-weight: 700;
}

.jiangli {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.reward-title {
    width: 90%;
    color: white;
}

.invite-reward {
    width: 95%;
    /* height: 300px; */
    margin: 15px auto;
    border-radius: 10px;
    background-color: #287537;
    padding-top: 2vh;
    padding-bottom: 2vh;
}



.url {
    float: left;
    transform: scale(0.8);
}

.url-wrap {
    width: 90%;
    margin: 0 auto;
    height: 6vh;
    line-height: 6vh;
    color: white;
    ;
    font-size: 0.2vh;
    font-weight: 700;
    background-color: rgb(44, 37, 37);
    border-radius: 1vw;
    margin-top: 1vh;
    text-align: left;
    position: relative;
}

.iurl {
    width: 90%;
    margin: 0 auto;
    height: 5vh;
    line-height: 5vh;
    color: white;
    ;
    font-size: 2vh;
    font-weight: 700;
}

.link-wrap {
    width: 95%;
    /* height: 300px; */
    margin: 15px auto;
    border-radius: 10px;
    background-color: #287537;
    padding-top: 2vh;
    padding-bottom: 2vh;
}

.l-title {
    text-align: center;
    font-weight: 700;
    color: #FCD949;
    height: 5vh;
    line-height: 5vh;
    font-size: 5vw;
}

</style>
<style lang="less" scoped>
.search-wrap {
    border: 3px solid white;
    height: 1.2rem;
    width: 94%;
    margin: 5px auto;
    border-radius: 10px;

}

.simg {
    width: 0.8rem;
    float: right;
    margin-top: 0.2rem;
    margin-right: 0.3rem;
}

.input-keyword {
    width: 70%;
    height: 100%;
    color: white;
    font-size: 0.48rem;
    //text-align: center;
    float: left;
    margin-left: 20px;
}

.item {
    width: 50%;
    float: left;
    height: 40px;
    line-height: 40px;
    color: white;
    font-weight: 700;
    font-size: 0.35rem;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid white;
    background-color: #1C6F26;

}

.hoho {
    width: 90%;
    // border: 1px solid white;
    margin: 15px auto;
    overflow: hidden;

}

.copy-img {
   
    margin-left: 15px;
    display: block;
    //margin: 15px auto 3px;
}

.r-wrap {
    width: 100%;
    margin: 0 auto;
    padding: 0 10px;
    background: #3a4a7c;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: linear-gradient(to right, rgb(60, 18, 71), rgb(38, 3, 27));
    border-radius: 15px;
}

.left-one {
    width: 50%;
    text-align: center;
    // height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    padding: 15px;

    border-bottom: 1px solid #090909;
}

.right-one {
    width: 50%;
    text-align: center;
    // height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    padding: 15px;
    border-left: 1px solid #090909;
    border-bottom: 1px solid #090909;
    color: gold;
    font-weight: 700;
}

.ewai {
    width: 95%;
    margin: 0 auto;
    padding: 0 10px;
    background: #3a4a7c;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: linear-gradient(to right, rgb(60, 18, 71), rgb(38, 3, 27));
    border-radius: 15px;
    //     background: url('../images/myteam/bg.png') 100% 100% no-repeat;
    //    background-size: cover;
}

.ic-rule div {
    font-size: 16px;
    margin-bottom: 5px;
    line-height: 30px;
    background: linear-gradient(to right, rgb(60, 18, 71), rgb(38, 3, 27));
    //    background: url('../images/myteam/bg.png') 100% 100% no-repeat;
    //    background-size: cover;
    padding: 10px;
    border-radius: 15px;
}

.ic-rule p {
    text-align: center;
    font-size: 16px;
    width: 50%;
    height: 38px;
    line-height: 30px;
    margin: 0 auto 8px;
    // background: url("../images/myteam/y.png") no-repeat;
    background-size: contain;
}

.ic-rule {
    width: 100%;
    padding: 10px 10px 0;
}

.all-com {
    width: 99%;
    //margin: 0px auto 0;
    //background: #0d7319;
    border-radius: 8px;
    padding: 10px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
}

.linkcode {
    text-align: center;
    font-size: 0.32rem;
    font-weight: 700;
    margin-top: 15px;
    color: white;
    display: flex;
    b {
      margin-left: 10px;
    }
}

.uid {
    text-align: center;
    font-size: 0.5rem;
    font-weight: 700;
    margin-top: 10px;
}

.uid2 {
  text-align: center;
  font-size: 0.5rem;
  font-weight: 700;
  margin-top: 10px;
  background-image: linear-gradient(to bottom, #FFFFFF, #97EBA7);
  color: transparent;
  -webkit-background-clip: text;
}

.userphone {
    text-align: center;
    font-size: 0.5rem;
    font-weight: 700;
    margin-top: 10px;
}

.avta {
    width: 80px;
    display: block;
    margin: -13px auto 3px;
}

.avta-div {
    width: 100%;
}

.top-bg {
    width: 98%;
    margin: 0 auto;
    padding: 20px;
    //background: url("../images/myteam/top_bg.png") no-repeat;
    background-size: contain;
    background-color: #0E4114;
}

.mid_bg {
  width: 98%;
  margin: 15px auto;
  padding: 20px;
  //background: url("../images/myteam/top_bg.png") no-repeat;
  background-size: contain;
  background-color: #0E4114;
}
.bottom_bg {
  width: 98%;
  margin: 15px auto;
  padding: 20px;
  //background: url("../images/myteam/top_bg.png") no-repeat;
  background-size: contain;
  background-color: #0E4114;
}

.invite_wrap {
    height: 100%;
    width: 100%;
    //background: url("../images/recharge/bg.png") no-repeat;
    background-size: cover;
}

.copy-btn {
    width: 15%;
    box-sizing: content-box;
    color: white;
    font-size: 0.38rem;
    background: #bc9e77;
    border-radius: 8px;
    height: 30px;
    margin-top: 2.5px;
    margin-left: 50%;
}

.really-code {
    font-weight: 700;
    font-size: 0.25rem;
}

.invitation-des {
    width: 85%;
    height: 35px;
    line-height: 40px;
    font-size: 0.38rem;
    color: #635032;
}

.people-des {
    color: #635032;
}

.recharge-count {
    color: #635032;
    font-weight: 700;
    font-size: 0.45rem;
}

.mem-count {
    color: #635032;
    font-size: 0.45rem;
}

.team-members,
.team-members-2 {
    color: #9e8757;
    font-size: 0.35rem;
}

.asset-mid {
    width: 95%;
    // display: flex;
    justify-content: center;
    align-content: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0ceb1;
}

.team-members {
    // width: 60%;
    height: 20px;
    line-height: 15px;
}

.team-members-2 {
    // width: 40%;
    height: 20px;
    line-height: 15px;
}

.asset-top {
    height: 75px;
    width: 100%;
    //background: #8d8d8f;
    display: flex;
}

.asset-btm {
    height: 80px;
    width: 100%;
    //background: #8d8d8f;
    // display: flex;
}

.btm-item {
    width: 33.33%;
}

.item-money {
    text-align: center;
    height: 40px;
    line-height: 50px;
    font-weight: 700;
    font-size: 0.45rem;
    color: #635032;
}

.item-des {
    text-align: center;
    height: 15px;
    line-height: 15px;
    //font-weight: 700;
    font-size: 0.35rem;
    color: #94866b;
}

.asset-top-left {
    width: 70%;
}

.asset-top-right {
    width: 30%;
}

.total-asset {
    height: 20px;
    line-height: 20px;
    color: #9e8757;
    font-size: 0.4rem;
    font-weight: 700;
}

.total-number {
    height: 50px;
    line-height: 50px;
    color: black;
    font-weight: 700;
    font-size: 0.75rem;
}

.team-info {
    width: 96%;
    margin-left: 2%;
    background: url("../images/team_bg.png");
    background-size: cover;
    border-radius: 6px;
    padding: 10px 15px 8px 15px;
    //height: 185px;
    //text-align: center;
}

.big_tit {
    position: absolute;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 25px;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
}

.phone-number {
    height: 60px;
    line-height: 30px;
    text-indent: 8px;
    color: white;
    font-size: 0.5rem;
    font-weight: 700;
}

.userinfo {
    width: 96%;
    margin: 15px auto;
    height: 60px;
    //background: red;
    display: flex;
    //justify-content: center;
}

.red_top_bg {
    height: 44px;
    background: url(../images/login.png) no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    border-radius: 0 0 20% 20%;

    .big_tit {
        position: absolute;
    }

    .back_right {
        position: absolute;
        top: 3px;
        right: 3px;
    }

    .introduce {
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        line-height: 25px;
        color: #ffffff;
        margin-top: 20px;

        .line {
            width: 36px;
            height: 10px;
        }

        .tit {
            margin: 0 12px;
            font-weight: bold;
        }

        .left_line {
            background: url(../images/user/left_icon.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .right_line {
            background: url(../images/user/right_icon.png) no-repeat center center;
            background-size: 100% 100%;
        }
    }

    .award_tip {
        font-size: 14px;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
        margin: 3px auto 0 auto;
    }
}

.tabs {
    display: flex;
    justify-content: space-between;
    text-align: center;
    margin-top: 15px;
    width: 88%;
    margin-left: 6%;

    p {
        width: 28%;
        padding: 10px 5px;
        //border-radius: 5px;
        color: #9ba3c8;
    }

    .active {
        //background: #f61a44;
        color: #fdd5ad;
        border-bottom: 1px solid #fdd5ad;
    }
}

.list {
    margin-top: 10px;
    width: 96%;
    margin-left: 2%;
    background: #2b3864;
    border-radius: 5px;

    .item {
        height: 52px;
        line-height: 52px;
        width: 98%;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #3a4a7c;
        color: #fff;

        p:nth-child(1) {
            font-size: 13px;
            color: #fff;
            margin-left: 8px;
        }

        p:nth-child(2) {
            flex: 1;
            margin-left: auto;
            text-align: right;
            font-size: 12px;
            color: #ffffff;
        }
    }
}

.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 30;

    .share_inner {
        width: 230px;
        height: 280px;
        position: absolute;
        top: 60%;
        left: 0;
        right: 0;
        margin: -232px auto 0 auto;
        background: url(../images/user/share_bg.png) no-repeat center center;
        background-size: 100% 100%;

        .earn {
            font-size: 32px;
            position: absolute;
            top: 112px;
            color: #fff;
            font-weight: bold;
            width: 100%;
            text-align: center;
        }

        .invite {
            font-size: 20px;
            position: absolute;
            top: 158px;
            color: #fff;
            width: 100%;
            text-align: center;
        }
    }

    .white_bg {
        width: 160px;
        height: 160px;
        background-color: #ffffff;
        position: absolute;
        top: 30px;
        left: 35px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 143px;
            height: 143px;
        }
    }

    .basic_btn {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        top: 175px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        width: 90%;
    }
}
.withdraw_button {
  display: flex;
  position: relative;
  margin: 10px 0 0;
  font-size: 20px;
  width: 100%;
  height: 50px;
  align-items: center;
  text-align: center;
  line-height: 50px;
  .withdraw_img {
    position: absolute;
    margin-left: -65px;
    margin-top: 13px;
    width: 25px;
    height: 25px;
  }
  div {
    background: #287537;
    width: 45%;
    margin: 0 auto;
    height: 50px;
    align-items: center;
    border-radius: 15px;
  }
  p {
    //margin: 00px;
    margin-left: 27px;
  }
}
.tab-head {
  display: flex;
  margin: 15px;
  //background: #0fec29;
  text-align: center;

  button {
    background: transparent;
    border: none;
    outline: none;
    padding: 0.5rem 0.5rem;
    cursor: pointer;
    width: 33.33%;
  }
  //.tab-button:hover {
  //  background-color: #0fec29;
  //}
  .tab-button  {
    background-color: #287537;
    font-size: 0.3rem;
  }
}
.tab-head .button-active {
  background-color: #FEEB02;
  color: #073F22;
}

.popup_style {
  height: 40%;
  width: 70%;
  background: #0e4114;
  .popup_yue {
    display: flex;
    margin: 10px;
    font-size: 20px;
    line-height: 20px;
    .total-asset2 {
      color: white;
    }
    .total-number2 {
      margin-left: 20px;
      color: gold;
    }
  }
  .popup_change {
    display: flex;
    margin: 10px;
    font-size: 20px;
    line-height: 20px;
    .total-asset3 {
      margin-top: 6px;
      color: white;
      width: 50%;
    }

    .total-number3 {
      margin-left: 20px;
      color: gold;
      width: 50%;
      //background-color: #1f51a6;
      border: 2px solid #ccc;
    }
  }
  .popup_button {
    position: fixed;
    display: flex;
    margin: 10px;
    font-size: 20px;
    bottom: 10px;
    .total-asset4 {
      //position: absolute;
      background: #198325;
      color: #bcc0ce;
      width: 2.8rem;
      margin: 10px;
      height: 40px;
      //bottom: 10px;
      //left: 50px;
    }
    .total-number4 {
      color: gold;
      width: 2.8rem;
      background: #198325;
      margin: 10px;
      height: 40px;
      //position: absolute;
      //bottom: 10px;
      //right: 50px;
    }
  }
}
</style>